module.exports = __webpack_public_path__ + "static/analyse_card-42a3002ac89bd207047552160161046d.png";